import { DirectUpload } from "@rails/activestorage"

export const FILE_CATEGORY_PATTERNS = [
  [["ntb", "notice", "notice_to_bid", "notice-to-bid", "noticetobid", "notice to bid"], "notice_to_bid"],
  [["addendum", "addenda"], "addendum"],
  [["tabulation", "bid_tab"], "bid_tabulations"],
  [["award", "bid_award"], "bid_awards"],
  [["qualification", "bid_qual"], "bid_qualifications"],
  [["budget", "bid info", "bidinfo", "bid_information"], "budget"],
  [["clarification"], "clarifications"],
  [["memo"], "memo"],
  [["drawing", "drawings", "plan", "plans", "dwg", "sheet", "sheets", "aia"], "drawings"],
  [["spec", "specs", "specification", "specifications"], "specifications"]
]

export function detectCategoryFromFilename(filename) {
  const normalized = filename.replace(/\s/g, "_").toLowerCase()
  for (const [keywords, category] of FILE_CATEGORY_PATTERNS) {
    if (keywords.some((kw) => normalized.includes(kw))) {
      return category
    }
  }
  return "miscellaneous"
}

export function isValidFileType(file, acceptedTypes) {
  return acceptedTypes.split(",").map((type) => type.trim()).some((type) => {
    if (type.startsWith(".")) {
      return file.name.toLowerCase().endsWith(type.toLowerCase())
    }
    return file.type.match(new RegExp(type.replace("*", ".*")))
  })
}

export function formatFileSize(bytes) {
  return bytes < 1024 * 1024
    ? `${(bytes / 1024).toFixed(0)} KB`
    : `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export function isPdf(file) {
  return file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf")
}

export function directUpload(file, url, delegate) {
  return new Promise((resolve, reject) => {
    const upload = new DirectUpload(file, url, delegate)
    upload.create((error, blob) => {
      if (error) {
        reject(error)
      } else {
        resolve(blob)
      }
    })
  })
}

export function blobRedirectPath(signedId, filename) {
  return `/rails/active_storage/blobs/redirect/${signedId}/${encodeURIComponent(filename)}`
}

export function updateUploadedFileLink(linkContainer, blob) {
  if (!linkContainer || !blob) return

  const signedId = blob.signed_id
  const filename = blob.filename
  if (!signedId || !filename) return

  const link = linkContainer.querySelector("a")
  if (link) {
    link.textContent = filename
    link.href = blobRedirectPath(signedId, filename)
    link.title = filename
    return
  }

  linkContainer.textContent = filename
}

export async function fetchPdfPageCount(signedId) {
  const response = await fetch(`/pages/files/pdf_page_count?id=${encodeURIComponent(signedId)}`)
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const data = await response.json()
  if (data.error) {
    throw new Error(data.error)
  }

  return data.page_count
}

export async function applyPdfPageCount(signedId, file, scope) {
  if (!isPdf(file)) return

  try {
    const pageCount = await fetchPdfPageCount(signedId)
    const pillElement = scope.querySelector('[data-js="pill"]')
    if (pillElement) {
      pillElement.textContent = pageCount === 1 ? `${pageCount} page` : `${pageCount} pages`
    }

    const pdfPagesInput = scope.querySelector('[data-active-storage-compact-target="pdfPages"]')
    if (pdfPagesInput) {
      pdfPagesInput.value = pageCount
    }
  } catch (error) {
    console.error("Error getting PDF page count:", error)
  }
}
